module.exports = __webpack_public_path__ + "static/img/icon-user.04bb69ee.png";